var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.21875 0.75C1.61914 0.75 0.375 2.03857 0.375 3.59375V14.9688C0.375 16.5684 1.61914 17.8125 3.21875 17.8125H23.125C24.6802 17.8125 25.9688 16.5684 25.9688 14.9688V3.59375C25.9688 2.03857 24.6802 0.75 23.125 0.75H3.21875ZM6.0625 14.9688H3.21875V12.125C4.77393 12.125 6.0625 13.4136 6.0625 14.9688ZM3.21875 6.4375V3.59375H6.0625C6.0625 5.19336 4.77393 6.4375 3.21875 6.4375ZM20.2812 14.9688C20.2812 13.4136 21.5254 12.125 23.125 12.125V14.9688H20.2812ZM23.125 6.4375C21.5254 6.4375 20.2812 5.19336 20.2812 3.59375H23.125V6.4375ZM13.1719 5.01562C14.6826 5.01562 16.0601 5.85986 16.8599 7.14844C17.6152 8.48145 17.6152 10.1255 16.8599 11.4141C16.0601 12.7471 14.6826 13.5469 13.1719 13.5469C11.6167 13.5469 10.2393 12.7471 9.43945 11.4141C8.68408 10.1255 8.68408 8.48145 9.43945 7.14844C10.2393 5.85986 11.6167 5.01562 13.1719 5.01562Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/Cash.2fee764fa09ce6f566c271031ba3418f.svg";
export { ForwardRef as ReactComponent };